export enum Permission {
	FullAccess = '*',
	AdministrarVendedores = 'AdministrarVendedores',
	RegistrarCliente = 'RegistrarCliente',
}
